import { useContext, useState } from "react";
import { DataContext } from "../contextData/contextData";

function getNumero() {
  const elm = document.querySelector('#inputCargo');
  if (!elm) { return ''; }

  const texto = elm.options[elm.selectedIndex].text;
  return texto.substr(texto.length - 1, 1).replace(/[A-Z]/g, '');
}

export const useUnidadRolTemporis = () => {
  const [rolTemporis, setRolTemporis] = useState(false);

  function actualizarRolTemporis() {
    const resp = getNumero();
    setRolTemporis(resp !== '');
  }

  return { rolTemporis, actualizarRolTemporis }
}

export const useReingreso = () => {
  const { reingresa, cambioReingresa } = useContext(DataContext);

  function setReingreso(booleanData) { cambioReingresa(booleanData); }

  return { reingresa, setReingreso }
}